import { go, some, html } from 'fxjs/es';
import { ProductMconTheme } from '../../../../../Product/MconTheme/S/Function/product-mcon-theme.ts';

export const buyLaterProductEditColumnTmpl = (up_c) => {
  const product_color = up_c._.product_color;
  const products_mcon_themes = product_color._.products_mcon_themes;
  const has_unpurchasable_designs =
    products_mcon_themes.length > 0 &&
    go(
      products_mcon_themes,
      some((theme) => {
        return !ProductMconTheme.checkProductsMconTheme(theme, G._en).result;
      }),
    );

  return html`
    ${has_unpurchasable_designs
      ? ''
      : html`<button class="omp-my-wish__add-to-cart">${TT('my_page::wish::wish_11')}</button>`}
    <button type="button" class="omp-my-wish__product-delete divided-edit-column">
      <img
        src="https://s3.marpple.co/files/u_1187078/2025/7/original/a4c4f20ec0b07c14099d45288fe70e93acce80981.png"
        alt="delete"
        width="14"
        height="14"
      />
    </button>
  `;
};
